const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";
const BASE_PATH = `${API_URL}/addresses`;

export const ADDRESS_ENDPOINTS = {
  BASE: BASE_PATH,
  GET: BASE_PATH,
  CREATE: BASE_PATH,
  UPDATE: BASE_PATH,
  DELETE: (id: string) => `${BASE_PATH}/${id}`,
  AUTOCOMPLETE: `${BASE_PATH}/autocomplete`,
  PLACE_DETAILS: `${BASE_PATH}/place-details`,
} as const;

export default ADDRESS_ENDPOINTS;
